import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import {
  getDashboardProjects,
  getFavouriteProjects,
} from '../../modules/project';
import ProjectWidget from './ProjectWidget';
import { Link } from 'react-router-dom';
import NoProject from './NoProject';
import { useNotification } from '../../hooks/NotificationContext';
// import { useAccess } from '../../hooks/useAccess';
import LatestData from './bottom-content/LatestData';
import SmallSectionLoader from '../elements/SmallSectionLoader';

const DashboardProjects = () => {
  const [loading, setLoading] = useState(true);
  const [recentProjects, setRecentProjects] = useState([]);
  const [favouriteProjects, setFavouriteProjects] = useState([]);
  const { addNotification } = useNotification();

  // const { canAccess } = useAccess();

  // const canViewLatestData =
  //   canAccess('ManageTestCases') ||
  //   canAccess('ManageTestCycles') ||
  //   canAccess('ViewProjectDashboard');

  const fetchProjectData = async () => {
    setLoading(true);
    try {
      const [recentRes, favRes] = await Promise.all([
        getDashboardProjects(5, 1, '', true),
        getFavouriteProjects(),
      ]);
      setRecentProjects(recentRes?.projects || []);
      setFavouriteProjects(favRes?.projects || []);
    } catch (error) {
      addNotification('danger', error.message || 'Failed to fetch projects');
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchProjectData();
  }, []);

  const allProjectIds = [
    ...new Set([...recentProjects, ...favouriteProjects].map((p) => p.id)),
  ];

  return (
    <div>
      <Row>
        <Col md="12">
          {loading ? (
            <SmallSectionLoader />
          ) : (
            <Container fluid className="px-0">
              {favouriteProjects.length > 0 && (
                <>
                  <Row className="d-flex flex-wrap">
                    <Col md="12" className="d-flex justify-content-between">
                      <h6>Favourite Projects</h6>
                      {recentProjects && recentProjects.length > 0 && (
                        <Link to="/projects">View All Projects</Link>
                      )}
                    </Col>
                    {favouriteProjects.map((project) => (
                      <Col key={project.id} className="dashboard-box">
                        <ProjectWidget project={project} />
                      </Col>
                    ))}
                  </Row>
                  <hr />
                </>
              )}

              <Row className="d-flex flex-wrap">
                <Col md="12" className="d-flex justify-content-between">
                  <h6>Recent Projects</h6>
                  {favouriteProjects?.length === 0 && (
                    <Link to="/projects">View All Projects</Link>
                  )}
                </Col>
                {recentProjects?.length > 0 ? (
                  recentProjects.map((project) => (
                    <Col key={project.id} className="dashboard-box">
                      <ProjectWidget project={project} minimal={true} />
                    </Col>
                  ))
                ) : (
                  <Col>
                    <NoProject fetchProjectData={fetchProjectData} />
                  </Col>
                )}
              </Row>
            </Container>
          )}
        </Col>
      </Row>

      {allProjectIds.length > 0 && (
        <>
          <hr />
          <LatestData projects={allProjectIds} />
        </>
      )}
    </div>
  );
};

export default DashboardProjects;
